export enum TokenValidationType {
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    REGISTRATION = 'REGISTRATION',
  }
  